import type { Config } from "../../../../aysa_api/shared/v1/config.types";
import type {
  CustomerSession,
  OptionalCustomerSession,
} from "../../../../aysa_api/shared/v1/session.types";

export enum SubscribeToNewsletterRequest_Gender {
  GENDER_UNSPECIFIED = 0,
  GENDER_FEMALE = 1,
  GENDER_MALE = 2,
}

export interface SubscribeToWhatsappNewsletterRequest {
  config: Config;
  session: CustomerSession;
  whatsappToken: string;
  // The country code sent by CRM
  // E.g. https://en.aboutyou.hu/auth?e_waChannelUser=value&countryCode=hu
  externalCountryCode: string;
}

export interface SubscribeToWhatsappNewsletterResponse {}

export interface SubscribeToNewsletterRequest {
  config: Config;
  session: OptionalCustomerSession;
  gender: SubscribeToNewsletterRequest_Gender;
  email: string;
}

export interface SubscribeToNewsletterResponse {}

export interface UnsubscribeFromNewsletterWithTokenRequest {
  config: Config;
  // Token and permission are obtained via the url parmeters from the unsibscribe link within the newsletter itself.
  token: string;
  permission: string;
}

export interface UnsubscribeFromNewsletterWithTokenResponse {}
